
import { defineComponent, ref } from "vue";
import ApiService from "@/core/services/ApiService";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { translate } from "@/core/services/HelpersFun";
export default defineComponent({
  name: "agency",
  components: {},
  setup() {
    const formData = ref({
      name: "",
      mobile: "",
      job: "",
      sales_history: "",
      time_in_month: "",
      description: "",
      why_inboxino: "",
      phone: "",
    });

    const submit = () => {
      if (
        formData.value.name === "" ||
        formData.value.mobile === "" ||
        formData.value.job === "" ||
        formData.value.sales_history === "" ||
        formData.value.description === "" ||
        formData.value.why_inboxino === "" ||
        formData.value.time_in_month === "" ||
        formData.value.phone === ""
      ) {
        Swal.fire({
          text: translate("To apply please fill in all the information"),
          icon: "info",
          buttonsStyling: false,
          confirmButtonText: translate("Ok"),
          customClass: {
            confirmButton: "btn fw-bold btn-light-info",
          },
        });
        return false;
      }
      ApiService.post("/agent/request", formData.value)
        .then(() => {
          Swal.fire({
            text: translate(
              "Your request has been successfully registered You will be contacted soon"
            ),
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: translate("Ok"),
            customClass: {
              confirmButton: "btn fw-bold btn-light-success",
            },
          }).then(() => {
            window.location.href = "/";
          });
        })
        .catch(() => {
          Swal.fire({
            text: translate(
              "An error occurred while registering the request Please check the information and try again"
            ),
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: translate("Try again"),
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        });
    };
    return {
      submit,
      formData,
      translate,
    };
  },
});
